import { forwardRef, useEffect, useMemo, useRef } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { MDBRow, MDBCol } from "mdbreact";

import "./D3CargoCarried.scss";

import { Button, Label, TextArea } from "abs-ui-components";

import { AUTOSAVE_SUCCESS_MESSAGE, DCommonTableLabel } from "../../Constants";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { API_ROUTES } from "../../ApiRoutes/ApiRoutes";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import AutoSave from "../../../../../common/AutoSave/AutoSave";

const D3CargoCarried = forwardRef(({ D3CargoCarriedData,vesselMstId, refetchMonitoringData }, ref) => {
    const { control, getValues, reset, formState } = useFormContext();
    const { isDirty } = formState;
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);

    useEffect(() => {
        if (D3CargoCarriedData) {
            reset(prev => ({ ...prev, d3: D3CargoCarriedData }));
        }
    }, [D3CargoCarriedData, reset]);

    AutoSave(ref, [], async () => {
        if (!isDirty) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("d3");
        const payload = {
            ...d3Fields.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        try {
            const D3CargoCarried = await callApi({
                method: "POST",
                url: API_ROUTES.D3(vesselMstId),
                data: payload,
            });
            if (D3CargoCarried?.isSuccess) {
                emitToasterMsg("success", "Table D.3", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, d3: formValues }));
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table D.3", D3CargoCarried?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table D.3", error?.errorMessage);
        }
    };

    const d3Fields = useMemo(() => {
        const base = DCommonTableLabel.filter(f => f.name !== "methodDescription");
        base.splice(1, 0, {
            label: "Description of method to treat data gaps",
            name: "descriptionOfMethodToTreatDataGaps",
            maxLength: 4000,
        });
        return base;
    }, []);

    return (
        <div className="d3-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of method</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">
                        Method to treat data gaps regarding cargo carried
                    </h6>
                </MDBCol>
            </MDBRow>

            {d3Fields.map(({ label, name, maxLength, type }, index) => (
                <MDBRow className="align-items-center mb-3" key={index}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        <Controller
                            name={`d3.${name}`}
                            control={control}
                            render={({ field }) => (
                                <TextArea
                                    id={`d3_${name}`}
                                    className="textarea-resize"
                                    value={field.value || ""}
                                    onChange={field.onChange}
                                    placeholder=""
                                    maxLength={maxLength}
                                    rows={1}
                                />
                            )}
                        />
                    </MDBCol>
                </MDBRow>
            ))}

            <div className="text-center">
                <Button id="d3_save_btn"
                    disabled={!isDirty}
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}>
                    Save
                </Button>
            </div>
        </div>
    );
});

export default D3CargoCarried;
